<template>
	<div>
		<app-layout>
			<template v-slot:header>
				<Header :title="$t('graduate_application_quotas')" :isNewButton="checkPermission('graduateapplicationquota_store')" :isFilter="false"
                        @new-button-click="createFormShow()" :is-import-button="checkPermission('graduateapplicationquota_excelimport')" @import-button-click="importData"
                        @filter-div-status="datatable.filterStatus = $event">
				</Header>
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile :title="$t('graduate_application_quotas')" :isNewButton="checkPermission('graduateapplicationquota_store')" :isFilter="false"
                              @new-button-click="createFormShow()" :is-import-button="checkPermission('graduateapplicationquota_excelimport')" @import-button-click="importData"
                              @filter-div-status="datatable.filterStatus = $event">
				</HeaderMobile>
			</template>
			<datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
				<b-row>
					<!-- SEMESTER ID -->
					<b-col sm="6" md="4">
						<b-form-group :label="$t('semester')">
							<semesters-selectbox type="text" v-model="datatable.queryParams.filter.semester_id"></semesters-selectbox>
						</b-form-group>
					</b-col>

					<!-- PROGRAM CODE -->
					<b-col sm="6" md="4">
						<b-form-group :label="$t('program')">
							<program-selectbox v-model="datatable.queryParams.filter.program_code" :faculty_code="34"></program-selectbox>
						</b-form-group>
					</b-col>

                    <!-- SEMESTER ID -->
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('quota')">
                            <b-form-input type="text" v-model="datatable.queryParams.filter.quota"></b-form-input>
                        </b-form-group>
                    </b-col>
				</b-row>
			</datatable-filter>
			<datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
				:total="datatable.total" :queryParams="datatable.queryParams" @on-page-change="onPageChange"
				@on-sort-change="onSortChange" @on-per-page-change="onPerPageChange" v-show="datatable.showTable">
			</datatable>
			<CommonModal ref="createFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
				<template v-slot:CommonModalTitle>
					{{ $t('new').toUpper() }}
				</template>
				<template v-slot:CommonModalContent>
					<create-form @createFormSuccess="createFormSuccess" v-if="formProcess == 'create'" />
				</template>
			</CommonModal>
			<CommonModal ref="updateFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
				<template v-slot:CommonModalTitle>
					{{ $t('edit').toUpper() }}
				</template>
				<template v-slot:CommonModalContent>
					<update-form :formId="formId" @updateFormSuccess="updateFormSuccess" v-if="formProcess == 'update'" />
				</template>
			</CommonModal>
			<CommonModal ref="importFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
				<template v-slot:CommonModalTitle>
					{{ $t('bulk_quota_assignment').toUpper() }}
				</template>
				<template v-slot:CommonModalContent>
					<import-form @successProcess="importFormSuccess" v-if="formProcess == 'import'" />
				</template>
			</CommonModal>
		</app-layout>
	</div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

// Components
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";

// Pages
import CreateForm from "./CreateForm";
import UpdateForm from "./Update.vue";
import ImportForm from "./ImportExcel"

// Services
import GraduateApplicationQuotasService from "@/services/GraduateApplicationQuotasService";

// Others
import qs from 'qs'

export default {
	components: {
		AppLayout,
		Header,
		HeaderMobile,
		DatatableFilter,
		Datatable,
		CommonModal,
		ProgramSelectbox,
		CreateForm,
		UpdateForm,
		ImportForm,
	},
	metaInfo() {
		return {
			title: this.$t('graduate_application_quotas')
		}
	},
	data() {
		return {
			datatable: {
				isLoading: false,
				columns: [
					{
						label: '',
						field: 'buttons',
						html: true,
						sortable: false,
						tdClass: 'p-0 text-center w-40 align-middle',
						buttons: [
							{
								text: this.$t('edit'),
								class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
								permission: "graduateapplicationquota_update",
								callback: (row) => {
									this.updateFormShow(row.id)
								}
							},
							{
								text: this.$t('delete'),
								class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
								permission: "graduateapplicationquota_delete",
								callback: (row) => {
									this.formDelete(row.id)
								}
							}
						]
					},
					{
						label: this.toUpperCase('id'),
						field: 'id',
						hidden: true,
					},
					{
						label: this.toUpperCase('academic_year'),
                        field: 'academic_year',
                        hidden: false,
					},
					{
						label: this.toUpperCase('semester'),
                        field: this.getLocaleField('semester_name'),
                        hidden: false,
					},
					{
						label: this.toUpperCase('program'),
						field: 'program_code',
						hidden: false,
					},
                    {
                        label: this.toUpperCase('quota'),
                        field: 'quota',
                        hidden: false,
                    }

				],
				rows: [],
				total: 0,
				filterStatus: true,
				showTable: false,
				queryParams: {
					filter: {},
					sort: 'id',
					page: 1,
					limit: 20
				}
			},
			formProcess: null,
			formId: null,
			form: {},
		}
	},
	created() {
		this.filterSet();
		this.formClear();
	},
	methods: {
		filterSet() {
			this.datatable.queryParams.filter = {
				id: null,
                semester_id: null,
                program_code: null,
                quota: null
			}
		},
		filterClear() {
			this.filterSet()
			this.getRows();
		},
		filter() {
			this.datatable.queryParams.page = 1;
			this.getRows();
		},
		onPageChange(params) {
			this.datatable.queryParams.page = params.currentPage;
			this.getRows();
		},
		onPerPageChange(params) {
			this.datatable.queryParams.limit = params.currentPerPage;
			this.datatable.queryParams.page = 1;
			this.getRows();
		},
		changeColumn(key) {
			this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
		},
		onSortChange(params) {
			const sortType = params[0].type == 'desc' ? '-' : '';
			this.datatable.queryParams.sort = sortType + params[0].field
			this.getRows();
		},
		getRows() {
			this.datatable.showTable = true;
			this.datatable.isLoading = true;

			const config = {
				params: {
					...this.datatable.queryParams
				},
				paramsSerializer: (params) => qs.stringify(params, { encode: false })
			};
			return GraduateApplicationQuotasService.getAll(config)
				.then((response) => {
					this.datatable.rows = response.data.data
					this.datatable.total = response.data.pagination.total

					this.datatable.rows.forEach((c) => c.status = c.status == 'a' ? this.$t('active') : this.$t('passive'))
				})
				.finally(() => {
					this.datatable.isLoading = false;
				});
		},
		// Clear
		formClear() {
			this.formId = null
			this.formProcess = null
		},

		// Create
		createFormShow() {
			this.formId = null
			this.formProcess = 'create'
			this.$refs.createFormModal.$refs.commonModal.show()
		},
		createFormSuccess() {
			this.$refs.createFormModal.$refs.commonModal.hide()
			this.getRows()
			this.formClear()
		},

		// Update
		updateFormShow(id) {
			this.formId = id
			this.formProcess = 'update'
			this.$refs.updateFormModal.$refs.commonModal.show()
		},
		updateFormSuccess() {
			this.$refs.updateFormModal.$refs.commonModal.hide()
			this.getRows()
			this.formClear()
		},

		formDelete(id) {
			this.$swal
				.fire({
					text: this.$t('are_you_sure_to_delete'),
					showCancelButton: true,
					confirmButtonText: this.$t('yes'),
					cancelButtonText: this.$t('no'),
				})
				.then((result) => {
					if (result.isConfirmed) {
						GraduateApplicationQuotasService.del(id)
							.then(response => {
								this.$toast.success(this.$t(response.data.message));
								this.getRows();
								this.formClear();
							})
							.catch(error => {
								this.$toast.error(this.$t(error.data.message));
							});
					}
				})
		},

		exportExcel() {
			const config = {
				params: {
					...this.datatable.queryParams
				},
				paramsSerializer: (params) => qs.stringify(params, { encode: false })
			};

			return GraduateApplicationQuotasService.exportExcel(config)
				.then((response) => {
					this._downloadFile(response, 'graduate_application_quotas.xlsx')
				})
				.catch(e => {
				});
		},
		importData() {
			this.formProcess = 'import'
			this.$refs.importFormModal.$refs.commonModal.show()
		},
		importFormSuccess() {
			this.formProcess = null;
			this.$refs.importFormModal.$refs.commonModal.hide()
		}
	}
}
</script>

